import {
  Accordion,
  AccordionItem,
  Group,
  NumberFormatter,
  SegmentedControl,
  Stack,
  Text,
  ThemeIcon,
  Title,
} from "@mantine/core";
import { useMemo, useState } from "react";
import { useReportingStore } from "../../../../stores/ReportingStore";
import EmailSummaryMulti from "./summary/EmailSummaryMulti";
import EmailSummary from "./summary/EmailSummary";
import EmailPerf from "./perf/EmailPerf";
import ReportingInfo from "../ReportingInfo";
import { IconEmail } from "../../../../assets/icons/IconEmail";
import { useLanguage } from "../../../../stores/LanguageStore";

const ReportingEmail = () => {
  const lang = useLanguage((s) => s.language);
  const [active, setActive] = useState("summary");
  const actualStatsDate = useReportingStore((s) => s.actualStatsDate);
  const programmations = useReportingStore((s) => s.programmations);

  const statistics = useMemo(() => {
    const totals = actualStatsDate.reduce((acc, curr) => {
      Object.keys(curr).forEach((key) => {
        if (key !== "date") {
          acc[key] = (acc[key] || 0) + curr[key];
        }
      });
      return acc;
    }, {});
    return totals;
  }, [actualStatsDate]);

  const component = useMemo(() => {
    if (active === "summary") {
      if (programmations.length > 1) {
        return <EmailSummaryMulti />;
      }
      return <EmailSummary />;
    }
    return <EmailPerf />;
  }, [active, programmations.length]);

  return (
    <Accordion variant="contained" radius={"md"} defaultValue={"activity"}>
      <AccordionItem value="activity" style={{ border: 0 }}>
        <Accordion.Control bg={"primary.0"}>
          <Group>
            <ThemeIcon
              variant="filled"
              radius={"md"}
              size={"lg"}
              color={"var(--mantine-color-secondary-5)"}
            >
              <IconEmail />
            </ThemeIcon>

            <Title order={3} fw={500}>
              {lang.reports.activity_email}
            </Title>
            <ReportingInfo>
              <Text>{lang.reports.activity_email_text}</Text>
            </ReportingInfo>

            <Text ml={"auto"} mr={32} size="lg">
              <NumberFormatter
                value={statistics.email_sent}
                style={{ fontWeight: 700 }}
              />{" "}
              {lang.reports.email_sent}
            </Text>
          </Group>
        </Accordion.Control>

        <Accordion.Panel bg={"var(--mantine-color-primary-2)"}>
          <Stack align="center" pt={8}>
            <SegmentedControl
              data={[
                {
                  label: lang.reports.sending_summary,
                  value: "summary",
                },
                {
                  label: lang.reports.performance,
                  value: "perf",
                },
              ]}
              value={active}
              onChange={setActive}
              size="lg"
            />

            {component}
          </Stack>
        </Accordion.Panel>
      </AccordionItem>
    </Accordion>
  );
};

export default ReportingEmail;
